import { STEP } from "#src/constants/step.ts";
import { defineStore } from "#src/stores/state-wrapper.js";

import { useStepBirthdateStore } from "#src/stores/step-birthdate.js";
import { useStepQuoteStore } from "#src/stores/step-quote.js";
import { useInstanceSettingsStore } from "#src/stores/instance-settings.js";
export const COMPARISON_TYPE = {
  ACCIDENTAL_DEATH: "accidentalDeath",
  FINAL_EXPENSE: "fex",
  TERM: "term",
  ROP_TERM: "ropTerm",
  LIFETIME: "lifetime",
  LTC: "ltc",
};

export const FACE_AMOUNT_TYPE = {
  FINAL_EXPENSE: "fex",
  LIFETIME: "lifetime",
  NON_MED: "non_med",
  TERM: "term",
  ROP_TERM: "ropTerm",
};

export const useStepCompareStore = (pinia, hot) =>
  defineStore("step-compare", {
    getters: {
      step: () => STEP.COMPARE,
      nextText: () => "Next - View Carriers",
      previous() {
        const birthdate = useStepBirthdateStore(pinia);
        if (birthdate.next === this.step) {
          if (birthdate.inactive) return birthdate.previous;
          return birthdate.step;
        }
        return STEP.LIFE_INSURANCE_PRIORITY;
      },
      controlsNext: () => true,
      next: () => {
        const quote = useStepQuoteStore(pinia);
        return quote.step;
      },
      inactive() {
        const instanceSettingsStore = useInstanceSettingsStore(pinia);
        return (
          instanceSettingsStore.onlyAccidentalDeath ||
          instanceSettingsStore.onlyOnePermanentProduct
        );
      },
    },
  })(pinia, hot);
